/** Indicador de estado sin conexion para el PWA. */
import { useEffect, useState } from 'react';
import { MobileIcon } from './MobileIcon';

export function OfflineIndicator() {
  const [online, setOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true,
  );

  useEffect(() => {
    function handleOnline() { setOnline(true); }
    function handleOffline() { setOnline(false); }
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      className="fixed left-1/2 z-50 -translate-x-1/2 rounded-full bg-warning-strong px-4 py-2 text-center text-sm font-medium text-white shadow-card"
      style={{ top: 'calc(env(safe-area-inset-top) + 12px)' }}
    >
      <div className="flex items-center justify-center gap-2">
        <MobileIcon name="wifi_off" className="h-5 w-5" />
        Sin conexión a internet
      </div>
    </div>
  );
}
